// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Box, Fab, Grid, Stack, Typography, } from '@mui/material';

// TODO: Import MUI icon
import { MusicNote, YouTube } from '@mui/icons-material';

// TODO: Import context
import { Context } from '../Common/Context';
import { Text } from '../Common/Text';

// TODO: Import custom component
import { ContentTitle, } from '../Common/TypographyTYH';
import StackImage from '../Common/StackImage';

const Interdisciplinary = ({ onClick }) => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component Interdisciplinary Rendered');

    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable
    const coverages = [
        {
            ID: 'UyzRQnQpFuo',
            Title: '貽園X音樂(環境篇)',
        },
        {
            ID: 'zRw7t8xbs_0',
            Title: '貽園X音樂(活動篇)',
        },
    ];

    // TODO: Define event
    const handleClicked = (coverage) => {
        onClick(coverage);
    };

    // TODO: Return component
    const RenderStackImage = ({ coverage }) => (
        <StackImage onClick={() => { handleClicked(coverage) }} hover={true}>
            <iframe
                src={`https://www.youtube.com/embed/${coverage.ID}`}
                style={{ aspectRatio: '16/9', border: 0, width: '100%', height: '100%' }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title={coverage.Title}
            ></iframe>
            <Typography sx={{ alignItems: 'start', color: 'white', display: 'flex', gap: 1, mt: 1, }} variant="body1">
                <MusicNote sx={{ color: 'white' }} />
                {coverage.Title}
            </Typography>
        </StackImage>
    );

    return (
        <Stack className="SectionInterdisciplinary" spacing={2} sx={{ m: 5 }}>
            <ContentTitle text={Text.MusicalWork.Interdisciplinary[context.language]} />
            <Grid container spacing={2} sx={{ mb: 2 }}>
                {
                    coverages.map((coverage, i) => (
                        <Grid key={i} size={{ xs: 12, md: 6 }}>
                            <RenderStackImage coverage={coverage} />
                        </Grid>
                    ))
                }
            </Grid>
            <Box sx={{ display: 'flex', justifyContent: 'center' }} >
                <Fab
                    color="primary"
                    onClick={() => { window.open('https://www.youtube.com/@pohtyhmusic', '_blank') }}
                    sx={{ zIndex: 0 }}
                    variant="extended"
                >
                    <YouTube sx={{ mr: 1 }} />
                    {Text.MusicalWork.Youtube[context.language]}
                </Fab>
            </Box>
        </Stack>
    );
};

export default React.memo(Interdisciplinary);